// chatSlice.js
import { createSlice,createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { notification } from 'antd';

export const fetchAllNotifications = createAsyncThunk(
  'chat/fetchAllNotifications',
  async (payload,{ rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/notifications/", payload);
      return response.data
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || 'Failed to fetch notifications');
    }
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    openChatId: null, // ID of currently opened chat
    allNotification:[],
     loading: false,
    error: null,
    fcmToken:null
  },
  reducers: {
    openChat: (state, action) => {
      state.openChatId = action.payload; // payload = chatId
    },
    closeChat: (state) => {
      state.openChatId = null;
    },
    allNotification:(state,action)=>{
      state.allNotification = action.payload;
    },
    notificationCount:(state, action)=>{
     let isExist= false;
     state.allNotification.find((noti)=>{
        if(noti.agreement_id == action.payload.id){
          noti.chat_count = noti.chat_count+1.
          isExist =  true;
        }
      })
      if(!isExist){
        state.allNotification.push({id:action.payload})
      }
      
    },
    setFcmToken:(state,action)=>{
            state.fcmToken = action.payload;

    }
  },
    extraReducers: (builder) => {
    builder
      .addCase(fetchAllNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.allNotification = action.payload;
      })
      .addCase(fetchAllNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { openChat, closeChat,allNotification,setFcmToken,notificationCount } = chatSlice.actions;
export default chatSlice.reducer;
